import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useDisclosure } from "../../hooks/useDisclosure";
import { marketingUrl } from "../../Config";

// Marketing pages live in the separate marketing app (data-revival.com); only
// auth routes (Sign in) stay inside this app.

function PublicNavbar() {
  const menu = useDisclosure();

  return (
    <nav className="bg-dark-bg/95 backdrop-blur-md border-b border-white/10 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-5 py-5 flex items-center justify-between">
        <a
          href={marketingUrl("/")}
          id="logo-nav"
          className="transition-opacity hover:opacity-80"
        >
          <img
            src="/DataRevival_REV_RGB.svg"
            alt="Data Revival Logo"
            className="w-[140px] md:w-[160px] h-auto"
          />
        </a>

        {/* burger icon */}
        <button
          className="md:hidden text-white/60 hover:text-white focus:outline-none transition-colors"
          onClick={menu.toggle}
          aria-label="Toggle menu"
        >
          {menu.isOpen ? (
            <X className="w-5 h-5" />
          ) : (
            <Menu className="w-5 h-5" />
          )}
        </button>

        {/* desktop menu */}
        <ul className="hidden md:flex items-center gap-6">
          <li>
            <a
              className="text-sm text-white/60 hover:text-white transition-colors font-medium"
              href={marketingUrl("/how-it-works")}
            >
              How it works
            </a>
          </li>

          <li>
            <a
              className="text-sm text-white/60 hover:text-white transition-colors font-medium"
              href={marketingUrl("/pricing")}
            >
              Pricing
            </a>
          </li>

          <li>
            <a
              className="text-sm text-white/60 hover:text-white transition-colors font-medium"
              href={marketingUrl("/about")}
            >
              About us
            </a>
          </li>

          <li>
            <a
              className="text-sm text-white/60 hover:text-white transition-colors font-medium"
              href={marketingUrl("/blog")}
            >
              Blog
            </a>
          </li>

          <li>
            <a
              className="text-sm text-white/60 hover:text-white transition-colors font-medium"
              href={marketingUrl("/contact")}
            >
              Contact
            </a>
          </li>

          <li className="border-r border-white/15 h-4" />

          <li>
            <Link
              className="text-sm text-white/60 hover:text-white transition-colors font-medium"
              to="/login"
            >
              Sign in
            </Link>
          </li>

          <li>
            <a
              className="bg-gradient-to-r from-[#00A3FF] to-[#0077CC] hover:shadow-lg hover:shadow-[#00A3FF]/30 text-white font-semibold text-sm transition-all duration-200 px-4 py-2 rounded-lg"
              href={marketingUrl("/pricing")}
            >
              Get started
            </a>
          </li>
        </ul>
      </div>

      {/* mobile menu */}
      {menu.isOpen && (
        <div className="md:hidden bg-dark-bg/95 backdrop-blur-md border-t border-white/10">
          <ul className="flex flex-col py-2">
            <li>
              <a
                className="text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors block px-5 py-3 font-medium"
                href={marketingUrl("/how-it-works")}
                onClick={menu.close}
              >
                How it works
              </a>
            </li>

            <li>
              <a
                className="text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors block px-5 py-3 font-medium"
                href={marketingUrl("/pricing")}
                onClick={menu.close}
              >
                Pricing
              </a>
            </li>

            <li>
              <a
                className="text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors block px-5 py-3 font-medium"
                href={marketingUrl("/about")}
                onClick={menu.close}
              >
                About us
              </a>
            </li>

            <li>
              <a
                className="text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors block px-5 py-3 font-medium"
                href={marketingUrl("/blog")}
                onClick={menu.close}
              >
                Blog
              </a>
            </li>

            <li>
              <a
                className="text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors block px-5 py-3 font-medium"
                href={marketingUrl("/contact")}
                onClick={menu.close}
              >
                Contact
              </a>
            </li>

            <li className="border-t border-white/10 my-1" />

            <li>
              <Link
                className="text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors block px-5 py-3 font-medium"
                to="/login"
                onClick={menu.close}
              >
                Sign in
              </Link>
            </li>

            <li className="px-5 py-3">
              <a
                className="bg-gradient-to-r from-[#00A3FF] to-[#0077CC] hover:shadow-lg hover:shadow-[#00A3FF]/30 text-white font-semibold text-sm transition-all duration-200 px-5 py-3 rounded-lg block text-center"
                href={marketingUrl("/pricing")}
                onClick={menu.close}
              >
                Get started
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default PublicNavbar;
